import * as _ from "lodash"

import {
    HorizAlignment,
    IProfileFilter,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    ISearchSort,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";


const vUI_AZR_Search_List: any = {
    WB_DOM: {
        WB_DOM: 'vUI_DOM_Search',
        id: 'WB_DOM_ID', id_ui: 'DOMAIN_ID', name: 'DOMAIN_ID', appType: 'Domain'
    },

    //MasterData - Circular
    WB_CIRCULAR_CONFIG: {
        WB_CIRCULAR_CONFIG: 'vUI_CircularConfig_Search',
        id: 'WB_CIRCULARCONFIG_ID', id_ui: 'CONFIG_ID', name: 'CONFIG_ID', appType: 'CircularConfig'
    },

    //MasterData - Customer
    WB_CUSTRPG: {
        WB_CUSTRPG: 'vCustRPG_Dup',
        id: 'WB_CUSTRPG_ID', id_ui: 'CUSTOMER_ID_REL', name: 'CUSTOMER_ID_REL', appType: ''
    },
    WB_PLAN: {
        WB_PLAN: 'vUI_Cust_Plan_Search',
        id: 'WB_PLAN_ID', id_ui: 'PLAN_ID', name: 'PLAN_ID', appType: 'Plan'
    },
    WB_CUSTH: {
        WB_CUSTH: 'vUI_Customer_Hierarchy_Search',
        id: 'WB_CUSTH_ID', id_ui: 'WB_CUST_HIER_ID', name: 'WB_CUST_HIER_ID', appType: 'CustomerHierarchy'
    },
    WB_CUST: {
        WB_CUST: 'vUI_Customer_Search',
        id: 'WB_CUST_ID', id_ui: 'CUST_ID', name: 'CUST_ID', appType: 'Customers'
    },
    WB_CUSTM: {
        WB_CUSTM: 'vUI_Customer_Type_Search',
        id: 'WB_CUSTM_ID', id_ui: 'CUSTM_ID', name: 'CUSTM_ID', appType: 'CustomerType'
    },
    WB_CUSTROLE: {
        WB_CUSTROLE: 'vUI_Source_Customer_Type_Search',
        id: 'WB_CUSTROLE_ID', id_ui: 'ROLE_ID', name: 'ROLE_ID', appType: ''
    },

    //MasterData - Entnerprise
    WB_COMPANY: {
        WB_COMPANY: 'vUI_Company_Search',
        id: 'WB_COMPANY_ID', id_ui: 'COMPANY_ID', name: 'COMPANY_ID', appType: ''
    },
    WB_MDSET: {
        WB_MDSET: 'vUI_MasterDataSet_Search',
        id: 'WB_MDSET_ID', id_ui: 'MDSET_ID', name: 'MDSET_ID', appType: 'MasterDataSet'
    },

    //MasterData - Other
    WB_BUSINESSUNIT: {
        WB_BUSINESSUNIT: 'vUI_BusinessUnit',
        id: 'WB_BUSINESSUNIT_ID', id_ui: 'BUSINESSUNIT_ID', name: 'BUSINESSUNIT_ID', appType: 'BusinessUnit'
    },
    WB_CLASSIFICATION_CONTROL: {
        WB_CLASSIFICATION_CONTROL: 'vUI_Classification_Control_Search',
        id: 'WB_CLASSIFICATION_CONTROL_ID',
        id_ui: 'CONTROL_POINT_ID',
        name: 'CONTROL_POINT_ID',
        appType: 'ClassificationControl'
    },
    WB_CLASSIFICATION: {
        WB_CLASSIFICATION: 'vUI_Classification_Search',
        id: 'WB_CLASSIFICATION_ID', id_ui: 'CLASSIFICATION_ID', name: 'CLASSIFICATION_ID', appType: 'Classification'
    },
    WB_CONTROL_POINT: {
        WB_CONTROL_POINT: 'vUI_Control_Point_Search',
        id: 'WB_CONTROL_POINT_ID', id_ui: 'CONTROL_POINT_ID', name: 'CONTROL_POINT_ID', appType: 'ControlPoint'
    },
    WB_CONTROL_POINTM: {
        WB_CONTROL_POINTM: 'vUI_Control_Point_Type_Search',
        id: 'WB_CONTROL_POINTM_ID',
        id_ui: 'CONTROL_POINT_TYPE_ID',
        name: 'CONTROL_POINT_TYPE_ID',
        appType: 'ControlPointType'
    },
    WB_CURRENCY: {
        WB_CURRENCY: 'vUI_Currency_Search',
        id: 'WB_CURRENCY_ID', id_ui: 'CURRENCY_ID', name: 'CURRENCY_ID', appType: 'Currency'
    },
    WB_DATAOBJECT: {
        WB_DATAOBJECT: 'vUI_DataObject_Search',
        id: 'WB_DATAOBJECT_ID', id_ui: 'DATAOBJECT_ID', name: 'DATAOBJECT_ID', appType: 'DataObject'
    },
    WB_EXCHANGERATEM: {
        WB_EXCHANGERATEM: 'vUI_ExchangeRateType_Search',
        id: 'WB_EXCHANGERATEM_ID',
        id_ui: 'EXCHANGE_RATE_TYPE_ID',
        name: 'EXCHANGE_RATE_TYPE_ID',
        appType: 'ExchangeRateType'
    },
    WB_GLACCT: {
        WB_GLACCT: 'vUI_General_Ledger_Account_Search',
        id: 'WB_GLACCT_ID', id_ui: 'GLACCOUNT_ID', name: 'GLACCOUNT_ID', appType: 'GeneralLedgerPolicy'
    },
    WB_GL: {
        WB_GL: 'vUI_General_Ledger_Search',
        id: 'WB_GL_ID', id_ui: 'GENERAL_LEDGER_ID', name: 'GENERAL_LEDGER_ID', appType: 'GeneralLedger'
    },
    WB_HIERARCHY: {
        WB_HIERARCHY: 'vUI_Hierarchy_Search',
        id: 'WB_HIERARCHY_ID', id_ui: 'HIERARCHY_ID', name: 'HIERARCHY_ID', appType: 'HierarchyBuilder'
    },
    WB_LE_SPEND: {
        WB_LE_SPEND: 'vUI_LE_Spend_Search',
        id: 'WB_LE_SPEND_ID', id_ui: 'CONTROL_POINT_ID', name: 'CONTROL_POINT_ID', appType: 'LESpend'
    },
    WB_PARTITION: {
        WB_PARTITION: 'vUI_Partition_Search',
        id: 'WB_PARTITION_ID', id_ui: 'PARTITION_ID', name: 'PARTITION_ID', appType: 'Partition'
    },
    WB_SALESAREA: {
        WB_SALESAREA: 'vUI_SalesArea_Search',
        id: 'WB_SALESAREA_ID', id_ui: 'SALESAREA_ID', name: 'SALESAREA_ID', appType: ''
    },
    WB_SALESORG: {
        WB_SALESORG: 'vUI_SalesOrg_Search',
        id: 'WB_SALESORG_ID', id_ui: 'SALESORG_ID', name: 'SALESORG_ID', appType: ''
    },
    WB_SEARCH: {
        WB_SEARCH: 'vUI_Search_Config_Search',
        id: 'WB_SEARCH_ID', id_ui: 'SEARCH_ID', name: 'SEARCH_ID', appType: 'SearchConfig'
    },
    WB_SOURCETYPE: {
        WB_SOURCETYPE: 'vUI_SourceType_Search',
        id: 'WB_SOURCETYPE_ID', id_ui: 'SOURCE_TYPE_ID', name: 'SOURCE_TYPE_ID', appType: 'SourceType'
    },
    WB_TAG: {
        WB_TAG: 'vUI_Tag_Search',
        id: 'WB_TAG_ID', id_ui: 'TAG_ID', name: 'TAG_ID', appType: 'Tags'
    },

    //MasterData - Product
    WB_AFFINITYSET: {
        WB_AFFINITYSET: 'vUI_AffinitySet',
        id: 'WB_AFFINITYSET_ID', id_ui: 'AFFINITYSET_ID', name: 'AFFINITYSET_ID', appType: 'AffinitySet'
    },
    WB_PRDATTRGRP: {
        WB_PRDATTRGRP: 'vUI_Product_Attribute_Group_Search',
        id: 'WB_PRDATTRGRP_ID', id_ui: 'ATTRIB_GROUP_ID', name: 'ATTRIB_GROUP_ID', appType: 'ProductAttributeGroup'
    },
    WB_PRDATTRMAP: {
        WB_PRDATTRMAP: 'vUI_Product_Attribute_Map_Search',
        id: 'WB_PRDATTRMAP_ID', id_ui: 'ATTRIB_MAP_ID', name: 'ATTRIB_MAP_ID', appType: ''
    },
    WB_PROD_BOM: {
        WB_PROD_BOM: 'vUI_Product_BOM_Diagnostic',
        id: '', id_ui: '', name: '', appType: ''
    },
    WB_PROD: {
        WB_PROD: 'vUI_Product_Search',
        id: 'WB_PROD_ID', id_ui: 'PRODUCT_ID', name: 'PRODUCT_ID', appType: 'Product'
    },
    WB_PRDM: {
        WB_PRDM: 'vUI_Product_Type_Search',
        id: 'WB_PRDM_ID', id_ui: 'PRDM_ID', name: 'PRDM_ID', appType: 'ProductType'
    },
    EXTPRD_ATR: {
        EXTPRD_ATR: 'vUI_Product_UPC_External_Attribute_Search',
        id: '', id_ui: '', name: '', appType: ''
    },
    PROD_CND: {
        PROD_CND: 'vUI_ProductCondition_Search',
        id: '', id_ui: '', name: '', appType: ''
    },
    PROD_CNDM: {
        PROD_CNDM: 'vUI_ProductConditionType_Search',
        id: '', id_ui: '', name: '', appType: ''
    },
    WB_PRDGRP: {
        WB_PRDGRP: 'vUI_ProductGroup_Search',
        id: 'WB_PRDGRP_ID', id_ui: 'PRODUCT_GROUP_ID', name: 'PRODUCT_GROUP_ID', appType: 'ProductGroups'
    },
    WB_PRDH: {
        WB_PRDH: 'vUI_ProductHierarchy_Search',
        id: 'WB_PRDH_ID', id_ui: 'HIERARCHY_ID', name: 'HIERARCHY_ID', appType: 'ProductHierarchy'
    },
    WB_UOM: {
        WB_UOM: 'vUI_UOM_Search',
        id: 'WB_UOM_ID', id_ui: 'UOM_ID', name: 'UOM_ID', appType: 'UOM'
    },
    WB_PRDGRPR: {
        WB_PRDGRPR: 'vWB_PrdGrpR_Dup',
        id: '', id_ui: '', name: '', appType: ''
    },

    //MasterData - Time
    WB_PERIODH: {
        WB_PERIODH: 'vUI_Period_Hierarchy_Search',
        id: 'WB_PERIODH_ID', id_ui: 'WB_PERIOD_HIER_ID', name: 'WB_PERIOD_HIER_ID', appType: 'PeriodHierarchy'
    },
    WB_PERIOD: {
        WB_PERIOD: 'vUI_Period_Search',
        id: 'WB_PERIOD_ID', id_ui: 'PERIOD_ID', name: 'PERIOD_ID', appType: 'Period'
    },
    WB_PERIODM: {
        WB_PERIODM: 'vUI_PeriodType_Search',
        id: 'WB_PERIODM_ID', id_ui: 'PERIOD_TYPE_ID', name: 'PERIOD_TYPE_ID', appType: 'PeriodType'
    },

    //PredictiveModeler
    WB_MODEL: {
        WB_MODEL: 'vUI_Model_Search',
        id: 'WB_MODEL_ID', id_ui: 'MODEL_ID', name: 'MODEL_ID', appType: 'Model'
    },
    WB_MODELING_SESSION: {
        WB_MODELING_SESSION: 'vUI_Model_Run_Search',
        id: 'WB_MODELING_SESSION_ID',
        id_ui: 'MODELING_SESSION_ID',
        name: 'MODELING_SESSION_ID',
        appType: 'ModelingSession'
    }
}


class SearchProvider
    implements ISearchProvider {
    _SQL: string
    _AddWhere: object[]
    _TableColumns: any[]
    _Profile: ISearchProfile

    constructor(sql: string, tableWhere: object[], tableColumns: any[], profile: ISearchProfile) {
        this._SQL = sql
        this._AddWhere = tableWhere
        this._TableColumns = tableColumns
        this._Profile = profile
    }

    get keyFields() {

        let vWB_Search_KeyFields = {
            id: 'WB_SEARCH_ID',
            id_ui: 'SEARCH_ID',
            name: 'SEARCH_ID'
        }
        return vWB_Search_KeyFields
    }


    get searchProviderFields() {
        const vWB_Search_Fields: { [id: string]: ISearchProviderField } = {}
        this._TableColumns.forEach(aCol => {
            vWB_Search_Fields[aCol.COLUMN_NAME] = {
                type:
                    aCol.dataType == "INT" || aCol.dataType == "INTEGER" || aCol.dataType == "DECIMAL" || aCol.dataType == "BIGINT" ? SearchProviderFieldType.number :
                        aCol.dataType == "NVARCHAR" || aCol.dataType == "STRING" || aCol.dataType == "string" ? SearchProviderFieldType.string :
                            aCol.dataType == "BOOLEAN" ? SearchProviderFieldType.boolean :
                                SearchProviderFieldType.string,
                renderOptions: {
                    columnName: aCol.COLUMN_NAME,
                    columnResourceName: `col${aCol.COLUMN_NAME}`,
                    alignment: HorizAlignment.Center
                },
                domainOptions: {}
            }
        })
        return vWB_Search_Fields
    }


    search(requestSpec: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            if (!_.isEmpty(this._AddWhere)) {
                this._AddWhere.forEach((where: any) => {
                    if (where.key && where.operator == '=') {
                        if (this._SQL.toLowerCase().indexOf("where") < 0)
                            this._SQL += " WHERE "
                        else
                            this._SQL += " AND"
                        this._SQL += where.key + '=' + where.value
                    }
                })
            }

            let findRequest = SearchUtils.makeSQLSearchRequest(
                this._SQL
            )
            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    let displayFields: string[] = <string[]>_.uniq(_.concat(this._Profile.profileDisplayFields, Object.values(this.keyFields)))

                    displayFields.filter(field => field)

                    let returnVals: any[] = []
                    _.forEach(res, aRow => {
                        let aVal: { [id: string]: any } = {}
                        _.forEach(displayFields, aField => {
                            aVal[aField] = aRow[aField]

                        })
                        if (!_.filter(returnVals, aRow => JSON.stringify(aVal) == JSON.stringify(aRow)).length) {
                            returnVals.push(aVal)
                        }
                    })
                    resolve(returnVals)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }


}

class SearchProfileSearchProfile
    implements ISearchProfile {

    constructor(tableName: string, tableWhere: object[], tableColumns: any[]) {
        this.tableName = tableName
        this.tableWhere = tableWhere
        this.tableColumns = tableColumns
        this.aSearchProvider = new SearchProvider(tableName, tableWhere, tableColumns, this)
    }

    tableName: string
    tableWhere: object[]
    tableColumns: any[]

    aSearchProvider: ISearchProvider = undefined

    profileId = "default"
    profileName = "Default Profile"
    renderOptions = {ui5ResourceId: "SearchProfileSearchProfile"}

    get profileFilter(): IProfileFilter[] {
        return [
            // {profileFilterName: 'ID', searchProviderFieldId: 'PROFILE_ID', renderOptions: {}},
            // {profileFilterName: 'Name', searchProviderFieldId: 'PROFILE_NAME', renderOptions: {}},
            {
                profileFilterName: 'ID',
                searchProviderFieldId: vUI_AZR_Search_List[this.tableName]['id'],
                renderOptions: {}
            },
            {
                profileFilterName: 'Name',
                searchProviderFieldId: vUI_AZR_Search_List[this.tableName]['name'],
                renderOptions: {}
            },
        ]
    }

    get profileDisplayFields(): string[] {
        let cols: any[] = []

        this.tableColumns.forEach(aCol => cols.push(aCol.COLUMN_NAME))
        return cols
    }

    profileSortIdDefault: ""
    profileSorts: ISearchSort[] = [];

    get profileSearchProvider() {
        return this.aSearchProvider
    }
}


export class SearchProfileSearch
    implements ISearch {
    constructor(tableName: string, tableWhere: object[], tableColumns: any[], options?: any) {
        this.tableName = tableName
        this.tableWhere = tableWhere
        this.tableColumns = tableColumns
        this.searchProfiles = [new SearchProfileSearchProfile(tableName, tableWhere, tableColumns)]
    }

    tableName: string
    tableWhere: object[]
    tableColumns: any[]

    searchName = "Select Profiles(s)"
    renderOptions = {ui5ResourceId: "SearchProfileSearch"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[] = []
    autoSearch = true

}
